import React from 'react';
import { Container, Stack, Typography } from '@mui/material';

const Faith = () => {
  return (
    <Container>
      <Typography variant="h3" align="center" gutterBottom>
        Faith
      </Typography>
      <Stack spacing={3}>
        <Typography variant="body1" align="center">
          My faith in God is the guiding light of my life. This is my testimony.
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{ textAlign: 'justify' }}
        >
          God has always been with me. From the beginning, His presence was
          undeniable. Jeremiah’s prophecy—that God knew me before I was
          conceived—is true. I was born in Ethiopia to loving parents. My
          mother, outspoken against corruption in Ethiopian authority, faced
          such grave danger that she had to leave the country, leaving behind
          her children and husband. Eventually, she settled in Seattle, where my
          siblings and I later joined her. For much of my early childhood, I was
          separated from my mother. Though that was difficult, I always felt
          protected and loved because God was with me. His presence was
          constant, and I always knew His love.
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{ textAlign: 'justify' }}
        >
          In Seattle, I initially struggled to adjust to the new culture,
          especially since I didn’t know English well. However, being young, I
          adapted quickly—but not always in the right ways. The culture
          influenced me, fostering independence and selfishness. Saturday
          nights, I would stay up late playing games, and by Sunday morning, all
          I wanted to do was sleep. My mom, however, insisted that I go to
          church. This led to frequent arguments, and at times, even discipline
          to get me out the door. These Sunday conflicts became routine. By the
          time I started high school, my mom gave me the freedom to choose
          whether to go to church. I chose not to. I was selfish, living only
          for myself. But something had to change—something needed to wake me up
          to the truth that life isn’t meant to be lived for yourself alone.
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{
            textAlign: 'justify',
            hyphens: 'auto',
            wordBreak: 'break-word',
          }}
        >
          During my senior year of high school, a friend and classmate, Sergio,
          suffered a brain aneurysm. I had seen him on Friday, and we went our
          separate ways for the weekend. On Monday, our teacher pulled us aside
          to tell us that Sergio had collapsed, was on life support, and
          encouraged us to visit him. Our class went to the hospital, and I’ll
          never forget seeing him hooked up to machines—physically there, yet
          absent. He had been fine, and then suddenly, he wasn’t. Life is so
          fragile. His family later made the heartbreaking decision to take him
          off life support, and he passed away. That period in my life was a
          blur, but it was a wake-up call. I wish I had grasped then how
          precious life is—a gift from God. But I didn’t. I remained selfish,
          unaware of God's grace, patience, and the gift of life itself.
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{ textAlign: 'justify' }}
        >
          One day during the second semester of my senior year, I was in
          computer class when, according to my classmates, I suddenly collapsed
          and began seizing. I woke up in an ambulance, my high school principal
          closing the door behind me. At the ER, doctors ran an MRI scan and
          discovered a tumor. My mind immediately went to Sergio—he had died
          from a brain condition, and now it felt like my turn. Fear gripped me,
          and I started searching for God, desperate for comfort. I read and
          listened to the Bible, but I didn’t understand it. I was like the
          Ethiopian eunuch in Acts, needing someone to guide me, just as Philip
          had done for him.
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{ textAlign: 'justify' }}
        >
          After high school, I underwent brain surgery. Because of the nature of
          the procedure, I had to remain awake as the surgeons asked me to move
          my fingers and toes mid-surgery. It was one of the most painful
          experiences of my life—the sensation of drilling and cutting into my
          skull was indescribable. Yet through it all, God protected me. He
          blessed me with skilled surgeons who completed the procedure without
          complications. My recovery was so swift that it even surprised my
          doctors—I was out of the hospital in just a few days. That healing was
          nothing short of God’s blessing. It was clear that God had His hand
          over me.
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{ textAlign: 'justify' }}
        >
          Even after surgery, I continued reading and listening to the Bible, as
          well as sermons, but I still needed someone to explain the truth to
          me. Then, on my first day of college, a man named Jake Tacher
          approached me with two others, inviting me to a Seahawks watch party
          that night. I said yes out of fear but had no real intention of going.
          Yet, for some reason, that evening, I got up, got on a bus, and went
          to that watch party with the man who had invited me.
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{ textAlign: 'justify' }}
        >
          When I arrived at Jake’s house, I was greeted by so many friendly
          faces. I didn’t know it at the time, but the campus ministry had
          gathered there to watch the game. I still remember it—Seahawks vs.
          Green Bay Packers. The referees were on lockout, so substitute refs
          officiated, and a crucial call at the end gave the Seahawks the win.
          But enough about the game! I left thinking, These people are nice, but
          I probably won’t see them again. Little did I know, Jake reached out a
          week later, inviting me to lunch to get to know me better. He told me
          he was part of a church in Seattle, and when I mentioned I was looking
          for a church, he asked if I’d be interested in studying the Bible.
          Without hesitation, I said yes—I was excited. For months, I studied
          the Bible, and then I made the biggest decision of my life. On
          February 3, 2013, I gave my life to Jesus Christ. I died to my old
          self and rose again through Him. My life now belongs to Him—fully and
          completely!
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{ textAlign: 'justify' }}
        ></Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{ textAlign: 'justify' }}
        ></Typography>
      </Stack>
    </Container>
  );
};

export default Faith;
